import ukMyson from '../../../shared/room-tables/UKMyson.table.json'
import swedenPurmo from '../../../shared/room-tables/SwedenPurmo.table.json'
import swedenThermotech from '../../../shared/room-tables/SwedenThermotech.table.json'
import polandPurmo from '../../../shared/room-tables/PolandPurmo.table.json'
import polandVN from '../../../shared/room-tables/PolandVN.table.json'
import germanyPurmo from '../../../shared/room-tables/GermanyPurmo.table.json'
import finlandPurmo from '../../../shared/room-tables/FinlandPurmo.table.json'
import denmarkPurmo from '../../../shared/room-tables/DenmarkPurmo.table.json'
import norwayPurmo from '../../../shared/room-tables/NorwayPurmo.table.json'
import romaniaPurmo from '../../../shared/room-tables/RomaniaPurmo.table.json'
import romaniaVN from '../../../shared/room-tables/RomaniaVN.table.json'
import franceFinimetal from '../../../shared/room-tables/FranceFinimetal.table.json'
import franceRadson from '../../../shared/room-tables/FranceRadson.table.json'
import belgiumRadson from '../../../shared/room-tables/BelgiumRadson.table.json'
import netherlandsRadson from '../../../shared/room-tables/NetherlandsRadson.table.json'
import polandRadson from '../../../shared/room-tables/PolandRadson.table.json'
import latviaPurmo from '../../../shared/room-tables/LatviaPurmo.table.json'
import latviaVN from '../../../shared/room-tables/LatviaVN.table.json'
import hungaryPurmo from '../../../shared/room-tables/HungaryPurmo.table.json'
import hungaryVN from '../../../shared/room-tables/HungaryVN.table.json'
import czechiaVN from '../../../shared/room-tables/CzechiaVN.table.json'
import slovakiaPurmo from '../../../shared/room-tables/SlovakiaPurmo.table.json'
import ukrainePurmo from '../../../shared/room-tables/UkrainePurmo.table.json'
import ukraineVN from '../../../shared/room-tables/UkraineVN.table.json'
import uzbekistanPurmo from '../../../shared/room-tables/UzbekistanPurmo.table.json'
import kazakhstanPurmo from '../../../shared/room-tables/KazakhstanPurmo.table.json'
import croatiaPurmo from '../../../shared/room-tables/CroatiaPurmo.table.json'
import croatiaVN from '../../../shared/room-tables/CroatiaVN.table.json'

const TABLES_BY_MARKET = {
  ukmyson: ukMyson,
  swedenpurmo: swedenPurmo,
  swedenthermotech: swedenThermotech,
  polandpurmo: polandPurmo,
  polandvn: polandVN,
  germanypurmo: germanyPurmo,
  finlandpurmo: finlandPurmo,
  denmarkpurmo: denmarkPurmo,
  norwaypurmo: norwayPurmo,
  romaniapurmo: romaniaPurmo,
  romaniavn: romaniaVN,
  francefinimetal: franceFinimetal,
  franceradson: franceRadson,
  belgiumradson: belgiumRadson,
  netherlandsradson: netherlandsRadson,
  polandradson: polandRadson,
  latviapurmo: latviaPurmo,
  latviavn: latviaVN,
  hungarypurmo: hungaryPurmo,
  hungaryvn: hungaryVN,
  czechiavn: czechiaVN,
  slovakiapurmo: slovakiaPurmo,
  ukrainepurmo: ukrainePurmo,
  ukrainevn: ukraineVN,
  uzbekistanpurmo: uzbekistanPurmo,
  kazakhstanpurmo: kazakhstanPurmo,
  croatiapurmo: croatiaPurmo,
  croatiavn: croatiaVN,
}

const normalizeMarket = (market) =>
  String(market || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, '')

export const getRoomTables = (market) => {
  const key = normalizeMarket(market)
  return TABLES_BY_MARKET[key] || ukMyson
}
